





























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ResyncFinddocBadgeModal extends Vue {
  // PROPS
  @Prop({ type: String, default: 'resync-finddoc-badge-modal' })
  readonly modalId: string;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Number, default: 0 }) readonly badgeId: number;
  public loading: boolean = false;

  openModal() {
    this.$bvModal.show(this.modalId);
  }

  closeModal() {
    this.$bvModal.hide(this.modalId);
  }

  onConfirm() {
    this.loading = true;
    const path = `${this.$bpcApiRouteHelper.getEntityPath('access-control-badges')}/${
      this.badgeId
    }/sync`;

    this.$bpcApi.put(path).subscribe(
      () => {
        this.$emit('badge-synced');
      },
      () => {
        this.$emit('error-syncing');
      },
      () => {
        this.loading = false;
      },
    );
  }

  @Watch('showModal')
  onShowModalChange(val: boolean) {
    if (val) {
      this.openModal();
    } else {
      this.closeModal();
    }
  }
}
